import { z } from 'zod';
import { uuidSchema } from './id.schemas.js';
/** The two "last N weeks" lengths the period select offers. */
export const LAST_N_WEEK_CHOICES = [13, 26];
/**
 * The one `period` shape every report endpoint takes (plan §5) — Reports now, the Board in Phase 5. The engine's
 * `resolveWeekRange` turns it into concrete weeks, so the Tracker, Reports and the Board can never disagree about
 * which weeks a period means. A custom range is checked there too: a reversed or over-cap range is refused, never
 * swapped or clamped.
 */
export const periodSchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('YTD') }),
    z.object({ kind: z.literal('QUARTER') }),
    z.object({ kind: z.literal('LAST_N'), n: z.union([z.literal(13), z.literal(26)]) }),
    z.object({ kind: z.literal('ALL') }),
    z.object({ kind: z.literal('CUSTOM'), fromWeekId: uuidSchema, toWeekId: uuidSchema }),
]);
/** A resolved period: the first and last week it covers, and whether it is the explicit "All weeks". */
export const resolvedPeriodSchema = z.object({
    kind: z.enum(['YTD', 'QUARTER', 'LAST_N', 'ALL', 'CUSTOM']),
    fromWeekId: uuidSchema,
    toWeekId: uuidSchema,
    all: z.boolean(),
});
//# sourceMappingURL=period.schemas.js.map